import React from 'react';
import { Link } from 'react-router-dom';

const SignupButton = ({
  onClick,
  className = '',
  children = null,
  text = '',
  to = '/login?mode=signup',
}) => {
  const label = children || text || 'SIGN UP';

  const styles = `inline-flex items-center justify-center bg-[#4CE470] text-[#113A28] px-6 py-2.5 rounded-full font-bold text-sm hover:bg-[#3bc45d] transition-all shadow-md active:scale-95 ${className}`;

  if (onClick) {
    return (
      <button onClick={onClick} className={styles}>
        {label}
      </button>
    );
  }

  return (
    <Link to={to} className={styles}>
      {label}
    </Link>
  );
};

export default SignupButton;